import { Component } from '@angular/core';

@Component({
  selector: 'app-link-ticket-preview',
  templateUrl: './link-ticket-preview.component.html',
  styleUrls: ['./link-ticket-preview.component.scss'],
})
export class LinkTicketPreviewComponent {}
